/**
 * «Quién habló cuánto»: proporción de habla, turnos, preguntas y monólogo más
 * largo por hablante (como las estadísticas de tl;dv). Se calcula en el
 * navegador desde la transcripción; no se guarda nada.
 */
import { useMemo } from 'react'
import type { TranscriptSegment } from '@eco/shared'
import { formatLength } from '../lib/format'
import { speakerStats } from '../lib/transcript'

export function SpeakerStatsCard({ segments }: { segments: TranscriptSegment[] }) {
  const stats = useMemo(() => speakerStats(segments), [segments])
  if (stats.length < 2) return null
  return (
    <details className="card tight">
      <summary style={{ cursor: 'pointer', fontSize: 13 }}>Quién habló cuánto</summary>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 10, fontSize: 12.5 }}>
        <thead>
          <tr className="faint" style={{ textAlign: 'left' }}>
            <th scope="col" style={{ fontWeight: 500 }}>
              Hablante
            </th>
            <th scope="col" style={{ fontWeight: 500, width: '40%' }}>
              Habló
            </th>
            <th scope="col" style={{ fontWeight: 500, textAlign: 'right' }}>
              Turnos
            </th>
            <th scope="col" style={{ fontWeight: 500, textAlign: 'right' }}>
              Preguntas
            </th>
            <th scope="col" style={{ fontWeight: 500, textAlign: 'right' }}>
              Monólogo más largo
            </th>
          </tr>
        </thead>
        <tbody>
          {stats.map((s) => {
            const pct = Math.round(s.share * 100)
            return (
              <tr key={s.speaker} style={{ borderTop: '1px solid var(--line-soft)' }}>
                <th scope="row" style={{ fontWeight: 500, textAlign: 'left', padding: '6px 0' }}>
                  {s.speaker}
                </th>
                <td>
                  <div className="row" style={{ gap: 6 }}>
                    <div
                      aria-hidden="true"
                      style={{
                        height: 6,
                        width: `${Math.max(pct, 2)}%`,
                        maxWidth: '70%',
                        background: 'var(--slate)',
                        borderRadius: 3
                      }}
                    />
                    <span>{pct} %</span>
                  </div>
                </td>
                <td style={{ textAlign: 'right' }}>{s.turnos}</td>
                <td style={{ textAlign: 'right' }}>{s.preguntas}</td>
                <td style={{ textAlign: 'right' }}>{formatLength(s.monologoMaxMs)}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </details>
  )
}
